<template>

    <div class="ml-center md:ml-center lg:ml-0 lg:container">
      <div class="sliderPoForfait mb-20 lg:mb-60">
        <div class="splide mb-20" aria-label="Slider offre mobile">
          <div class="splide__track">
            <ul class="splide__list">

              <li v-for="(forfait, index) in sortedForfaits" :key="index" class="splide__slide item relative">
                <span v-if="forfait.field_type_de_promotion" class="jumperSimple absolute top-0 left-0">
                  <span v-if="forfait.field_type_de_promotion == 1">
                    Ed. Spéciale {{ forfait.field_titre_de_la_promotion }}<sup>*</sup>
                  </span>
                  <span v-if="forfait.field_type_de_promotion == 2">
                    Ed. Limitée {{ forfait.field_titre_de_la_promotion }}<sup>*</sup>
                  </span>
                </span>
                <span v-else v-if="forfait.field_etiquette_forfait" class="jumperSimple absolute top-0 left-0">
                  {{ forfait.field_etiquette_forfait }}
                </span>
                <span v-if="forfait.field_5g" class="jumper5g jumper5g--light absolute top-0 right-0" :class="colors[forfait.field_couleur_de_fond]?.jumperClass || colors.white.jumperClass"><span>5G</span></span>
                <div class="pt-40 pb-10 px-20" :class="colors[forfait.field_couleur_de_fond]?.bgClass || colors.white.bgClass">

                  <div class="mb-15">
                    <p class="text-sm text-bold leading-20">Forfait</p>
                    <p class="text-26 text-bold leading-30 mb-10" :class="colors[forfait.field_couleur_de_fond]?.colorData || colors.white.colorData">
                      <template v-if="forfait.field_appels && forfait.field_appels > 0">
                        {{ forfait.field_appels }}h
                      </template>
                        {{ forfait.field_internet }}Go <span class="text-base"></span>
                    </p>
                  </div>

                  <div class="mb-20">
                    <span class="text-bold"><span class="c-orange text-xl leading-24">{{ Number(forfait.field_prix_forfait).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                  </div>

                  <div class="text-center">
                    <a @click.prevent="$emit('loadDialog', $event);taggage('carte_offre', 'voir_en_detail', (forfait.field_internet + 'go').replace(/\s+/g, '_'), { tealium_event: 'select_content' })" :data-forfaitid="forfait.nid" href="javascript:void(0)" class="block underline hover:no-underline font-bold text-sm py-10 jsModaleBtn">Voir en détail</a>
                  </div>
                </div>

                <div class="border-t2-grey15 border-t2-grey15--js">
                  <button @click="selectForfait($event);taggage('carte_offre', 'choisir_ce_forfait', (forfait.field_internet + 'go').replace(/\s+/g, '_'), { tealium_event: 'select_content' })" :data-id="forfait.nid" class="hover:bg-orange hover:c-white w-full h-50 text-center pointer text-bold chooseForfait" :class="colors[forfait.field_couleur_de_fond]?.bgBtn || colors.white.bgBtn" type="button">Choisir ce forfait</button>
                </div>

                <div v-for="(mobile, indexmobile) in data_etape2.mobile" class="border-t2-grey15 border-t2-grey15--js px-20 py-15 relative" :class="colors[forfait.field_couleur_de_fond]?.bgMobile || colors.white.bgMobile">
                  <div class="relative z-1">
                    <p class="text-bold text-sm leading-20" :class="colors[forfait.field_couleur_de_fond]?.colorBrand || colors.white.colorBrand">{{ mobile.field_marque }}</p>
                    <p class="text-bold leading-22 mb-10">{{ mobile.title }}</p>
                    <p>
                      <span class="text-sm">Tarif avec ce forfait</span><br/>
                      <span class="text-bold text-base"><span class="c-orange">{{ Number(mobile[typePrice[forfait.field_niveau_prix_mobile]]).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                    </p>
                  </div>
                  <span class="dflex w-50 absolute top-20 right-20" :class="colors[forfait.field_couleur_de_fond]?.colorSvg || colors.white.colorSvg"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 61 84"><path fill="currentColor" fill-rule="evenodd" d="m6.0395 65.9513 34.1652 9.1545 15.7186-58.6626-34.1652-9.1546L6.0395 65.9513Zm15.3372 11.0943c-1.1798-.3162-1.8754-1.5454-1.5541-2.7447.3217-1.2004 1.5384-1.9161 2.7182-1.5999 1.1798.3161 1.8746 1.5439 1.5529 2.7443-.3213 1.1993-1.5372 1.9164-2.717 1.6003ZM36.8025 6.6621l6.4061 1.7165c.5899.158.9373.772.7767 1.371-.1611.6014-.7689.9593-1.3588.8013l-6.406-1.7165c-.5899-.158-.9373-.772-.7762-1.3734.1605-.599.7683-.957 1.3582-.799Zm20.8724 3.263L23.5006.7683c-2.3576-.6305-4.7894.8037-5.431 3.2026L.6046 69.1515c-.644 2.3982.745 4.8561 3.102 5.4889l34.1743 9.157c2.3576.6305 4.7894-.8037 5.431-3.2025L60.777 15.4142c.6438-2.3983-.7451-4.8562-3.1021-5.489Z" clip-rule="evenodd"/></svg></span>
                </div>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>

</template>

<script setup>
import { ref, computed } from 'vue';
import { onMounted, nextTick } from 'vue';
import { taggage } from '@/utils/taggage.js';

const data_etape2 = ref({});
const error_etape2 = ref(null);
const isLoading = ref(true);


defineExpose({
  data_etape2
});

const props = defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  tag: Object
});

const colors = {
  black: { bgClass: 'bg-black c-white poCardFiber', jumperClass: 'gradient-white c-white', bgBtn: 'bg-black c-white', colorSvg: 'c-grey14', bgMobile: 'bg-black c-white', colorData: 'c-orange', colorBrand: 'c-greyLight'},
  grey: { bgClass: 'bg-grey14 c-white', jumperClass: 'gradient-white c-white', bgBtn: 'bg-grey14 c-white', colorSvg: 'c-grey11', bgMobile: 'bg-grey14 c-white', colorData: 'c-white', colorBrand: 'c-greyLight'},
  white: { bgClass: 'bg-white c-black', jumperClass: 'gradient-grey c-black', bgBtn: 'bg-white c-black', colorSvg: 'c-grey15', bgMobile: 'bg-white', colorData: 'c-black', colorBrand: 'c-grey11'},
}


//defineEmits(['switchToEtape3']);

const emit = defineEmits(['switchToEtape3','enableSelect','loadChooseMultiligne','loadDialog','incrementRecapKey']);

const typePrice = ["field_prix_card", "field_prix_silver", "field_prix_gold", "field_prix_platine", "field_prix_elite"];

const sortedForfaits = computed(() => {
  if (!data_etape2.value?.forfaits) return [];

  return Object.values(data_etape2.value.forfaits)
    .sort((a, b) => Number(a.field_poids) - Number(b.field_poids));
});

function selectForfait(event) {
  emit('enableSelect');
  emit('loadChooseMultiligne');
  var forfait = event.target;
  if (forfait.classList.contains('bg-white') && forfait.classList.contains('c-black')) {
    forfait.classList.remove("bg-white","c-black");
    forfait.classList.add("bg-orange", "c-white");
  }
  if (forfait.classList.contains('bg-grey14') && forfait.classList.contains('c-white')) {
    forfait.classList.remove("bg-grey14","c-white");
    forfait.classList.add("bg-orange", "c-white");
  }
  if (forfait.classList.contains('bg-black') && forfait.classList.contains('c-white')) {
    forfait.classList.remove("bg-black","c-white");
    forfait.classList.add("bg-orange", "c-white");
  }
  const liParent = forfait.closest('li');
  if (liParent) {
    liParent.classList.add("isSelected");
  }
  forfait.textContent = "Forfait sélectionné";
  props.parcours.forfait = forfait.dataset.id;
  emit('incrementRecapKey'); // informe le parent
  //props.parcours.mobile = mobile.dataset.id;
  //console.log('Parcours Mobile:'+props.parcours.value);

  const buttons = document.querySelectorAll('.chooseForfait');
  buttons.forEach(btn => {
    if (btn !== forfait) {
      const parent = btn.parentElement;
      const prevSibling = parent.previousElementSibling;
      btn.classList.remove('bg-orange','c-white','bg-white','c-black','bg-black'); // supprime 'toto' sur tous les autres
      if (prevSibling.classList.contains('bg-white') && prevSibling.classList.contains('c-black')) {
        btn.classList.add("bg-white", "c-black");
      }
      if (prevSibling.classList.contains('bg-grey14') && prevSibling.classList.contains('c-white')) {
        btn.classList.add("bg-grey14", "c-white");
      }
      if (prevSibling.classList.contains('bg-black') && prevSibling.classList.contains('c-white')) {
        btn.classList.add("bg-black", "c-white");
      }
      btn.textContent = "Choisir ce forfait";
      const liParentOther = btn.closest('li');
      if (liParentOther) {
        liParentOther.classList.remove("isSelected");
      }
    }
  });
}



onMounted(async () => {
  try {
    const params = new URLSearchParams({
      mobile: props.parcours.mobile,
      multiligne: 0
    });
    const res = await fetch(`/packopenv3/etape2?${params}`);
    if (!res.ok) throw new Error(`Erreur HTTP ${res.status}`);
    data_etape2.value = await res.json();
    await nextTick();
    slidersPoForfait();
    if (props.parcours.forfait != 0) {
      //console.log('Forfait Existe');
      const bouton = document.querySelector('.chooseForfait[data-id="' + props.parcours.forfait + '"]');
      if (bouton) {
        bouton.click();
      }
    }
  } catch (e) {
    error_etape2.value = e.message;
  } finally {
    isLoading.value = false;
  }
});



</script>
